<template>
  <transition name="slide">
    <div
      v-if="status.length"
      class="column status justify-center align-center grid-12"
    >
      <div
        v-for="(s, i) in status"
        :key="'status' + i"
        :class="
          (s.show ? 'showStatus' : '') +
          ' row grid-11-s grid-6 content content-' +
          s.color
        "
      >
        <div class="grid-11">{{ s.text }}</div>
        <div class="grid-1 row justify-end pointer" @click="REMOVE_STATUS(i)">
          <i class="fa fa-times"></i>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "Status",
  components: {},
  methods: {
    ...mapMutations("general", ["REMOVE_STATUS"]),
  },
  computed: {
    ...mapGetters("general", ["status"]),
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.status {
  position: fixed;
  z-index: 1000;
  bottom: 0px;

  .content {
    padding: 20px 15px;
    color: $gray-2;
    font-weight: bold;
    border-radius: 7px;
    margin-bottom: -500px;
    margin-top: 5px;
    &-green {
      background-color: $green-2;
    }
    &-red {
      background-color: $red;
      color: white;
    }
    &-orange {
      color: white;
      background-color: $orange-1;
    }
    &-white {
      background-color: white;
    }
  }
  .showStatus {
    transition: all ease-out 800ms;
    margin-bottom: 0px;
  }
}
</style>
